<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header">
          <h3>신청내역</h3>
        </div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              <label for="">대리점 추천 요금제</label>
            </dt>
            <dd class="field-control">
              <select v-model="tempPpCd" class="input-width-xlarge">
                <option value="">선택하세요</option>
                <option
                  v-for="item in phonePayStyleList"
                  :key="item.code"
                  :value="item.code"
                  >{{ item.name }}</option
                >
              </select>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label for="">고객님이 선택하신 요금제</label>
            </dt>
            <dd class="field-control">
              <input
                v-model="retrieveData.ppNm"
                type="text"
                @input="onlyText"
                name="ppNm"
                class="input-text input-font input-text-disabled input-width-xlarge"
                readonly
                title="요금제"
              />
              <ul class="notice-text-list">
                <li class="notice-text">
                  대리점 추천 요금제 외 다른 요금제 선택을 원하시면 해당
                  대리점으로 연락하시기 바랍니다.
                </li>
              </ul>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConnectedCarFeePlanSection',
  props: {},
  data() {
    return {
      retrieveData: {
        ppNm: '',
        ppCd: ''
      },
      phonePayStyleList: [],
      tempPpCd: ''
    }
  },
  computed: {},
  mounted() {
    this.retrieveData.ppNm = this.$store.state.connectedCar.common.phonePayStyle
    this.retrieveData.ppCd = this.$store.state.connectedCar.common.phonePayStyleCd
    this.phonePayStyleList = this.$store.state.connectedCar.common.phonePayStyleList
    this.tempPpCd = this.$store.state.connectedCar.common.phonePayStyleCd
  },
  watch: {
    tempPpCd(){
      for(const item of this.phonePayStyleList){
        if(item.code == this.tempPpCd){
          this.retrieveData.ppNm = item.name
          this.retrieveData.ppCd = this.tempPpCd
        }
      }
    }
  },
  methods: {
    /** 
     * Function    : onlyText
     * Description : input값 텍스트 체크
     **/
    onlyText(e) {
      this.retrieveData[e.target.name] = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
    },
  }
}
</script>

<style scoped></style>
